import { render, staticRenderFns } from "./WorkcenterChart.vue?vue&type=template&id=1bc81c69"
import script from "./WorkcenterChart.vue?vue&type=script&lang=js"
export * from "./WorkcenterChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports